const santaTalking = [
  {
    sentence : 'That is correct, you can now choose a letter, see if it is in the solution and keep on playing! Ho Ho Ho',
  },
  {
    sentence : 'Yes I was actually green before! Go on Choose a letter!',
  },
  {
    sentence : 'My incredible Sled tracted by... Uhh go ahead choose a letter...',
  },
  {
    sentence : 'I almost jinxed it Ha Ha. You can choose a letter',
  },
  {
    sentence : 'Ho Ho Ho!',
  },
  {
    sentence : 'Hopefully you are saying the truth!',
  },
  {
    sentence : 'That is the least you can do! I give you present every year!',
  },
  {
    sentence : 'Congratulation!!! The person who is gonna get my present is :',
  },
  {
    sentence : 'ANd the present isss...',
  },
  {
    sentence : 'A lovely cinema evening!',
  },
];

export default santaTalking;